export default __webpack_public_path__ + "static/media/thumbnail.56bb052b.png";